import React, { useState } from "react";
import { useModulesManager, useTranslations, Autocomplete, useGraphqlQuery } from "@stssocialst-stp/fe-core";
import { MODULE_NAME } from "../constants";

const TicketAttachmentPredefinedTypePicker = ({
  onChange,
  readOnly,
  required,
  value,
  filterSelectedOptions,
  multiple,
  ticketGeneralType,
  withLabel,
  withPlaceholder,
  ticketAttachmentType,
}) => {
  const modulesManager = useModulesManager();
  const { formatMessage } = useTranslations(MODULE_NAME, modulesManager);
  const [variables, setVariables] = useState({});

  const { isLoading, data, error } = useGraphqlQuery(
    `
    query{ 
      ticketAttachmentType(first: 20) 
      {        
        edges {
          node {
              id
              isAutogenerated
              ticketGeneralType
              ticketAttachmentType
          }
        }
      }    
    }    
  
    `,
    variables,
    { skip: true },
  );

  const filterOptions = (options) => {
    return options.filter((option) => {
      return option.ticketGeneralType === ticketGeneralType;
    });
  };

  return (
    <Autocomplete
      multiple={multiple}
      required={required}
      placeholder={formatMessage("ticketAttachmentType.placeholder")}
      label={formatMessage("ticket.ticketAttachment.predefinedType")}
      withLabel={withLabel}
      withPlaceholder={withPlaceholder}
      error={error}
      readOnly={readOnly}
      options={data?.ticketAttachmentType?.edges.map((edge) => edge.node) ?? []}
      isLoading={isLoading}
      value={value}
      getOptionLabel={(option) => `${option.ticketAttachmentType}`}
      onChange={(predefinedType) => onChange(predefinedType)}
      filterOptions={filterOptions}
      filterSelectedOptions={filterSelectedOptions}
      onInputChange={(search) => setVariables({ search, ticketAttachmentType: ticketAttachmentType })}
    />
  );
};

export default TicketAttachmentPredefinedTypePicker;